var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicOutdoorpark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.299,
    height: 12.087,
    viewBox: "0 0 9.299 12.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.38.1A1.068,1.068,0,0,1,1.59-.2,1.091,1.091,0,0,1,1.292-1v-9.945a1.016,1.016,0,0,1,.28-.765,1.064,1.064,0,0,1,.774-.272H6.528a4.325,4.325,0,0,1,2.992.96A3.433,3.433,0,0,1,10.591-8.33a3.459,3.459,0,0,1-1.071,2.7,4.3,4.3,0,0,1-2.992.969H3.485V-1a1.091,1.091,0,0,1-.3.808A1.091,1.091,0,0,1,2.38.1ZM6.256-6.341q2.261,0,2.261-1.972T6.256-10.285H3.485v3.944Z",
    transform: "translate(-1.292 11.985)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicOutdoorpark);
export default __webpack_public_path__ + "static/media/public_outdoorpark.effea3906a2e4800e69ea47f7f6dc5db.svg";
export { ForwardRef as ReactComponent };